const valueToFormData = value =>
  value === undefined || value === null ? '' : value

export default (formData, name) =>
  ([key, value]) =>
    formData.append(`${name}[${key}]`, valueToFormData(value))
